import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { EmojiPeopleIcon } from "./icons";
import { waiterRequest } from "../services/waiter";

function RequestWaiterButton({ shopId, tableId, className = "p-2 m-2" }) {
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState(null);

  const onWaiterRequest = async (event) => {
    try {
      setLoading(true);
      const response = await waiterRequest(shopId, tableId);
      if (response.ok) {
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onCloseModal = (event) => setStatus(null);

  return (
    <>
      <Button
        className={className}
        variant="outline-shop"
        onClick={onWaiterRequest}
        disabled={loading}
      >
        {loading ? (
          <Spinner animation="border" size="sm" className="me-2" />
        ) : (
          <EmojiPeopleIcon className="me-2" />
        )}
        Chamar Garçom
      </Button>
      <Modal centered show={status !== null} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Chamar Garçom
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {status === true && (
            <h5 className="p-3">
              Notificamos um Garçom da nossa equipe.
              <br />
              Em breve ele virá te atender.
            </h5>
          )}
          {status === false && (
            <h5 className="p-3">
              Opss...
              <br />
              Ocorreu um erro ao chamar o Garçom.
            </h5>
          )}

          <Button
            className="my-3 p-3"
            variant="outline-dark"
            onClick={onCloseModal}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RequestWaiterButton;
